import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'bootstrap';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Chart } from "react-google-charts";
import { IAM_API_BASE_URL_2, SCHEDULE_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';
import DateService from '../../services/DateService';
import TapHelper from '../../services/TapHelper';


const ProjectTimeLineChart = forwardRef((props, ref) => {

    const access_token                  =   useSelector(state => state.auth.access_token);

    let ticketDataUrl                   =   IAM_API_BASE_URL_2 + "/project/tickets";



    useImperativeHandle(ref, () => ({
        loadTicketsDataHandler      :   ()  =>  loadTicketsData()
    }));



    let initListData = {
        loading: false,
        items: []
    };
    const [itemData, setItemData] = useState(initListData);

    useEffect(() => {
        setItemData(pd => ({ ...pd, loading: true }));
        if (props?.project_id && props?.project_id != null && props?.project_id != '') {
            loadTicketsData();
        }
    }, [props.project_id]);


    const loadTicketsData = () => {
        setItemData(pd => ({ ...pd, loading: true }));
        HttpAPICall.withAthorization('GET', ticketDataUrl, access_token, { project_id: props.project_id }, {}, (response) => {
            setItemData(pd => ({ ...pd, items: response.data }));
        }).then(() => {
            setItemData(pd => ({ ...pd, loading: false }));
        });
    }


    const rows                  =   [];
    const colors                =   [];

    itemData.items.forEach((item) => {

        const startText             =   item.status === 0 ? 'Tentative' : '';
        const tentativeText         =   (item.status === 26 || item.status === 22) ? '' : 'Tentative';

        const baseColor             =   item.status_data.status_color_code;
        const darkColor             =   TapHelper.darkenColor(baseColor);       

        const startDate             =   new Date(item.start_date);
        const estimatedEnd          =   new Date(startDate);
        estimatedEnd.setDate(
            estimatedEnd.getDate() + Number(item.estimate_days)
        );
        const resolutionDate        =   new Date(item.resolution_date);
        const headerText            =   `${item.header}${item.is_in_critical_path === 'Y' ? '*' : ''}`;

        const excess_days           =   item.estimated_resolution_days - item.estimate_days;


        let tooltip = `
            <div style="padding:8px">
                <div style="text-decoration: underline;"><strong>${item.header}</strong></div>
                <div><strong>Status:</strong> ${item.status_data?.status_text ?? ''}</div>
                <div><strong>${startText} Start Date:</strong> ${DateService.dateFormat(item.start_date)}</div>
                <div><strong>${tentativeText} Resolved Date:</strong> ${DateService.dateFormat(item.resolution_date)}</div>`;
            if(excess_days > 0) {
                tooltip += `<div><strong>Estimated Resolved Date:</strong> ${DateService.dateFormat(estimatedEnd)}</div>`;
            }
        tooltip += `
                <div><strong>Critical Path:</strong> ${item.is_in_critical_path}</div>
                <div><strong>Reason for Delay:</strong> ${item.reason_for_delay ?? ''}</div>
            </div>
        `;

        // Only one bar
        if (item.estimate_days >= item.estimated_resolution_days) {
            rows.push([
                item.activity_id + `${item.is_in_critical_path === 'Y' ? '*' : ''}`,
                `${headerText} (${item.estimated_resolution_days})`,
                tooltip,
                startDate,  
                resolutionDate
            ]);
            colors.push(baseColor);
        } else {
            rows.push([
                item.activity_id + `${item.is_in_critical_path === 'Y' ? '*' : ''}`,
                `${headerText} (${item.estimate_days})`,
                tooltip,
                startDate,
                estimatedEnd
            ]);
            colors.push(baseColor);
            rows.push([
                item.activity_id + `${item.is_in_critical_path === 'Y' ? '*' : ''}`,   
                `${headerText} (${excess_days})`,
                tooltip,
                estimatedEnd,
                resolutionDate
            ]);
            colors.push(darkColor);
        }
    });

    const data = [
        [
            { type: 'string', id: 'Ticket Id' },
            { type: 'string', id: 'Header' },
            { type: "string", role: "tooltip" },
            { type: 'date', id: 'Start' },
            { type: 'date', id: 'End' }
        ],
        ...rows
    ];


    const options = {
        // allowHtml           :   true,
        colors              :   colors,
        // timeline            :   {
        //     groupByRowLabel     :   true,
        //     colorByRowLabel     :   true,
        // },
    };

    return <>
        {itemData.loading
            ? <Loader />
            : <Chart
                chartType="Timeline"
                data={data}
                width="100%"
                height="77vh"
                options={options}
            />
        }
    </>
});



export default ProjectTimeLineChart;